import { classes } from 'html-classes';
import { CSSProperties } from 'react';
import { Link } from 'react-router-dom';

// eslint-disable-next-line
import { useCategoryAnalytics } from '~/hooks/useCategoryAnalytics'; // prevent import cycle
import CategoryBlockTitle from '~/components/CategoryBlocks/CategoryBlockTitle';
import {
  createCategoryUrl,
  cfSrcForImage,
} from '~/components/CategoryBlocks/utils';
import Swiper from '~/components/Swiper/Swiper';
import { useGlobal } from '~/hooks/useGlobal';

import styles from './CategoriesCarouselCircleBlock.module.scss';
import { CategoriesCarouselCircleBlockProps } from './interfaces';

const CIRCLE_SIZE = 120;

const CategoriesCarouselCircleBlock = (
  props: CategoriesCarouselCircleBlockProps,
) => {
  const { className, category } = props;
  const { handleClickCategory } = useCategoryAnalytics();
  const { isMobile } = useGlobal();

  return (
    <div
      className={classes([styles.root, className])}
      style={
        {
          '--circle-size': `${CIRCLE_SIZE}px`,
        } as CSSProperties
      }
    >
      <CategoryBlockTitle
        text={category.name}
        className={styles.title}
        categoryId={category.id}
      />

      <Swiper
        sliderClassName={styles.slider}
        slideClassName={styles.slide}
        rightArrowClassName={styles.rightArrow}
        leftArrowClassName={styles.leftArrow}
        spaceBetween={isMobile ? 12 : 35}
        slidesPerViewProp="auto"
        isPagination={isMobile}
      >
        {category.subcategory.map(({ id, previewImage, previewText, name }) => (
          <Link
            onClick={handleClickCategory(id)}
            to={createCategoryUrl({ id })}
            className={styles.link}
            key={id}
          >
            <div className={styles.item}>
              {previewImage ? (
                <img
                  src={cfSrcForImage(previewImage, {
                    width: CIRCLE_SIZE,
                    height: CIRCLE_SIZE,
                  })}
                  alt=""
                />
              ) : (
                <div className={styles.emptyImg} />
              )}
            </div>
            <div className={styles.itemTitle}>{previewText || name}</div>
          </Link>
        ))}
      </Swiper>
    </div>
  );
};

export default CategoriesCarouselCircleBlock;
